module.exports = __webpack_public_path__ + "img/shop.a14a45bb.svg";